
import { gql } from '@apollo/client';

export default gql`
  query VendorAccountTlv($vendorAccountId: ID!) {
    VendorAccountTlv(vendorAccountId: $vendorAccountId) {
      id
      name
      value
      vendorAccountId
      isHash
    }
  }
`


